import Swiper from "swiper/dist/js/swiper.js";

export default {
	init() {
	// JavaScript to be fired on all pages


		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		/*
		// browser check
		/*
		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */

		// Opera 8.0+
		var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
		if (isOpera == true){
			$('html').addClass('opera');
		}

		// Firefox 1.0+
		var isFirefox = typeof InstallTrigger !== 'undefined';
		if (isFirefox == true){
			$('html').addClass('firefox');
		}

		// Safari 3.0+ "[object HTMLElementConstructor]"
		var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
		if (isSafari == true){
			$('html').addClass('safari');
		}

		// Internet Explorer 6-11
		var isIE = /*@cc_on!@*/false || !!document.documentMode;
		if (isIE == true){
			$('html').addClass('ie');
		}

		// Edge 20+
		var isEdge = !isIE && !!window.StyleMedia;
		if (isEdge == true){
			$('html').addClass('edge');
		}

		// Chrome 1+
		var isChrome = !!window.chrome && !!window.chrome.webstore;
		if (isChrome == true){
			$('html').addClass('chrome');
		}
        $('body').on('click', '.btn-play', function () {
            $(this).parent().find('video').get(0).play();
            $(this).hide();
            $(this).parent().find('video').attr('controls','true');
            return false;
        })


		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		/*
		// search
		/*
		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		if ($('header .search-btn').length > 0){
			$('header .search-btn').on('click', function (e) {
				e.preventDefault();
				$(this).toggleClass('is-active');
				if ($(this).hasClass('is-active')) {
					$('body').addClass('no-scroll');
					$('.search-dropdown').addClass('open');
					$('.search-dropdown input[type="search"]').focus();
					$('a').attr('tabindex', '-1');
					$('button').attr('tabindex', '-1');
					$('.swiper-pagination-bullet').hide();
					$('iframe').addClass('hidden');
					$('.search-dropdown input').attr('tabindex', '0');
					$('.search-dropdown a').attr('tabindex', '0');
					$('.page-overlay').show();
				} else {
					$('body').removeClass('no-scroll');
					$('.search-dropdown').removeClass('open');
					$('.search-dropdown input[type="search"]').blur();
					$('a').attr('tabindex', '0');
					$('button').attr('tabindex', '0');
					$('.swiper-pagination-bullet').show();
					$('iframe').removeClass('hidden');
					$('header .search-btn').focus();
					$('.page-overlay').hide();
				}
			});
			$('.search-dropdown .close').on('click', function (e){
				e.preventDefault();
				$('body').removeClass('no-scroll');
				$('header .search-btn').removeClass('is-active');
				$('.search-dropdown').removeClass('open');
				$('.search-dropdown input[type="search"]').blur();
				$('a').attr('tabindex', '0');
				$('button').attr('tabindex', '0');
				$('.swiper-pagination-bullet').show();
				$('iframe').removeClass('hidden');
				$('header .search-btn').focus();
				$('.search-dropdown input').attr('tabindex', '-1');
				$('.search-dropdown a').attr('tabindex', '-1');
				$('.page-overlay').hide();
			});
		}

		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		/*
		// hamburger
		/*
		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		if ($('.hamburger').length > 0){
			$('.hamburger').on('click', function () {
				$(this).toggleClass('is-active');
				if ($(this).hasClass('is-active')) {
					$('body').addClass('no-scroll');
					$('header nav').addClass('open');
					$('a').attr('tabindex', '-1');
					$('button').attr('tabindex', '-1');
					$('.swiper-pagination-bullet').hide();
					$('iframe').addClass('hidden');
					$('header nav a').attr('tabindex', '0');
					$('header .hamburger').attr('tabindex', '0');
					$('.page-overlay').fadeIn(400);
					$('.overlay').fadeIn(400);
				} else {
					$('body').removeClass('no-scroll');
					$('header nav').removeClass('open');
					$('a').attr('tabindex', '0');
					$('button').attr('tabindex', '0');
					$('.swiper-pagination-bullet').show();
					$('iframe').removeClass('hidden');
					$('header nav a').attr('tabindex', '-1');
					$('.page-overlay').fadeOut(400);
					$('.overlay').fadeOut(400);
				}
			});
		}

		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		/*
		// scrollto
		/*
		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		if ($('.scrollto').length > 0){
			$('.scrollto').on('click', function (e) {
				e.preventDefault();
				let section = $(this).attr('href');
				$('html, body').animate({
					scrollTop: $(section).offset().top
				}, 1000);
			});
		}

		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		/*
		// lazy load
		/*
		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		if ("IntersectionObserver" in window) {
			var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

			if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
				let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
					entries.forEach(function(entry) {
						if (entry.isIntersecting) {
							let lazyImage = entry.target;
							lazyImage.src = lazyImage.dataset.src;
							lazyImage.srcset = lazyImage.dataset.srcset;
							lazyImage.classList.remove("lazy");
							lazyImageObserver.unobserve(lazyImage);
						}
					});
				});

				lazyImages.forEach(function(lazyImage) {
					lazyImageObserver.observe(lazyImage);
				});
			}
		} else {
			console.log('Your Browser is WAY out of date!');

			let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
			let active = false;

			const lazyLoad = function() {
				if (active === false) {
					active = true;

					setTimeout(function() {
						lazyImages.forEach(function(lazyImage) {
						if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
							lazyImage.src = lazyImage.dataset.src;
							lazyImage.srcset = lazyImage.dataset.srcset;
							lazyImage.classList.remove("lazy");

							lazyImages = lazyImages.filter(function(image) {
								return image !== lazyImage;
							});

							if (lazyImages.length === 0) {
								document.removeEventListener("scroll", lazyLoad);
								window.removeEventListener("resize", lazyLoad);
								window.removeEventListener("orientationchange", lazyLoad);
							}
						}
						});

						active = false;
					}, 200);
				}
			};

			document.addEventListener("scroll", lazyLoad);
			window.addEventListener("resize", lazyLoad);
			window.addEventListener("orientationchange", lazyLoad);
		}

		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		/*
		// sticky scroll
		/*
		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		function sitckyShare(){
			if ($('#sidebar').length){
				if ($(window).width() > 1024 && $(window).height() > 767) {
					var sidebar = new StickySidebar('#sidebar', {
						containerSelector: '#main-content',
						innerWrapperSelector: '.sidebar__inner',
						topSpacing: 50,
						bottomSpacing: 0
					});
					sidebar.updateSticky();
					console.log('sticky');
				} else {
					$('#sidebar .sidebar__inner').removeAttr('style');
					console.log('remove sticky');
				}
			}
		}
		sitckyShare();

		$(window).on('resize', function(){
			sitckyShare();
		});

		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		/*
		// author hover
		/*
		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		if ($(window).width() > 1025) {
		  console.log($('.author-hover'));
      $('.author-hover').on('mouseenter', function() {
        $(this).parents('.author-item').find('.author-box').addClass('open');
      }).on('mouseleave', function() {
        $(this).parents('.author-item').find('.author-box').removeClass('open');
      });
			/*$('.author-hover').hover(function(e) {
				$(this).parent().next().children('.author-box').addClass('open');
			}, function(e){
				$(this).parent().next().children('.author-box').removeClass('open');
			});
			$('.author-hover').focus(function(e){
				$(this).parent().next().children('.author-box').addClass('open');
			});
			$('.author-hover').blur(function(e){
				$(this).parent().next().children('.author-box').removeClass('open');
			});*/
			$('.author-hover').on('click', function(e){
				return false;
			});
		} else {
			$('.author-hover').on('click, touchstart', function(e){
				$(this).parent().next().children('.author-box').addClass('open');
				return false;
			});
			$('.author-box .close').on('click, touchstart', function(e){
				$(this).parent().removeClass('open');
        return false;
			});
		}


		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		/*
		// hero slider
		/*
		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		if ($('.hero .swiper-container').length){
			var counter = 0;
			let slides = $('.hero .swiper-container .swiper-slide').length;
			if (slides < 2){
				$('.hero .hero-pagination, .hero .swiper-prev, .hero .swiper-next').hide();
			}
			$('.hero .swiper-container').each(function (i) {
				var swiperParams = {
					// autoplay: {
					// 	disableOnInteraction: false,
					// },
					slidesPerView: 1,
					loop: true,
					speed: 1200,
					preloadImages: false,
					loopAdditionalSlides:1,
					lazy: true,
					simulateTouch: false,
					queueStartCallbacks: true,
					queueEndCallbacks: true,
					keyboard: {
						enabled: true,
						onlyInViewport: true,
					},
					a11y: {
						enabled: true,
						prevSlideMessage: 'Previous slide',
						nextSlideMessage: 'Next slide',
						paginationBulletMessage: 'Go to slide {{index}}',
					},
					navigation: {
						nextEl: '.swiper-next',
    					prevEl: '.swiper-prev',
					},
					pagination: {
						el: '.hero-pagination',
						type: 'bullets',
						clickable: true,
					},
					breakpoints: {

					},
					on: {
						init: function(swiper){
							var myslide = this.activeIndex;

							$('.start-stop-slider').on('click', function(e){
								e.preventDefault();
								if ($(this).children('.pause').hasClass('active')){
									$(this).children('.pause').removeClass('active');
									$(this).children('.play').addClass('active');
									heroSlider.autoplay.stop();
								} else {
									$(this).children('.pause').addClass('active');
									$(this).children('.play').removeClass('active');
									heroSlider.autoplay.start();
								}
							});

							$('.swiper-slide').attr('aria-hidden','true');
							$('.swiper-slide-active').attr('aria-hidden','false');
							var focusAbles = $('.swiper-wrapper').find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');

							focusAbles.each(function() {
								$(this).attr('data-default-tabindex', function() {
									if ($(this).attr("tabindex")) {
										return $(this).attr('tabindex');
									} else {
										return "none";
									}
								});
							});
							focusAbles.attr('tabindex', '-1');
							setTimeout(function(){$('.swiper-slide-active').attr('aria-hidden','false');
								var focusAbles = $('.swiper-slide-active').find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');

								focusAbles.each(function() {
									$(this).attr('tabindex', function() {
										if ($(this).attr("data-default-tabindex") !="none") {
											return $(this).attr('data-default-tabindex');
										} else {
											$(this).removeAttr('tabindex');
										}
									});
								});
								focusAbles.removeAttr('data-default-tabindex');
								focusAbles.attr('tabindex', '0');
								$(".swiper-notification").text("Slide "+(myslide +1) +" displayed");
							}, 0);
						},
	  					slideChange: function(swiper){
							var myslide = this.activeIndex;

							$('.swiper-slide').attr('aria-hidden','true');

							/*make all non-focusable*/
							var focusAbles = $('.swiper-wrapper').find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');

							focusAbles.each(function() {
								if (!$(this).attr("data-default-tabindex")){
									$(this).attr('data-default-tabindex', function() {
										if ($(this).attr("tabindex")) {
											return $(this).attr('tabindex');
										} else {
											return "none";
										}
									});
								}
							});
							focusAbles.attr('tabindex', '-1');
							setTimeout(function(){$('.swiper-slide-active').attr('aria-hidden','false');
								var focusAbles = $('.swiper-slide-active').find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');

								focusAbles.each(function() {
									$(this).attr('tabindex', function() {
										if ($(this).attr("data-default-tabindex") !="none") {
											return $(this).attr('data-default-tabindex');
										} else {
											$(this).removeAttr('tabindex');
										}
									});
								});
								focusAbles.removeAttr('data-default-tabindex');
								focusAbles.attr('tabindex', '0');
								$(".swiper-notification").text("Slide "+(myslide +1) +" displayed");
							}, 0);
						},
						slideChangeTransitionStart: function () {
							counter += 60;
							$('#pyramid').css('transform', 'rotateY(' + counter + 'deg)');
							$('#pyramid2').css('transform', 'rotateY(' + counter + 'deg)');
						},
					},
				}
				var heroSlider = new Swiper($(this), swiperParams);
			});

		}

		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		/*
		// infographic slider
		/*
		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		if ($('.infographic .swiper-container').length){
			let slides = $('.infographic .swiper-container .swiper-slide').length;
			if (slides < 2){
				$('.infographic .infographic-pagination, .infographic .swiper-prev, .infographic .swiper-next').hide();
			}
			$('.infographic .swiper-container').each(function (i) {
				var swiperParams = {
					autoplay: false,
					slidesPerView: 1,
					loop: true,
					speed: 1200,
					preloadImages: false,
					lazy: true,
					autoHeight: true,
					simulateTouch: false,
					queueStartCallbacks: true,
					queueEndCallbacks: true,
					keyboard: {
						enabled: true,
						onlyInViewport: false,
					},
					a11y: {
						enabled: true,
						prevSlideMessage: 'Previous slide',
						nextSlideMessage: 'Next slide',
						paginationBulletMessage: 'Go to slide {{index}}',
					},
					navigation: {
						nextEl: '.swiper-next',
						prevEl: '.swiper-prev',
					},
					pagination: {
						el: '.infographic-pagination',
						type: 'bullets',
						clickable: true,
					},
					breakpoints: {

					},
					on: {
						init: function () {
							var myslide = this.activeIndex;

							$('.swiper-slide').attr('aria-hidden','true');
							$('.swiper-slide-active').attr('aria-hidden','false');
							var focusAbles = $('.swiper-wrapper').find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');

							focusAbles.each(function() {
								$(this).attr('data-default-tabindex', function() {
									if ($(this).attr("tabindex")) {
										return $(this).attr('tabindex');
									} else {
										return "none";
									}
								});
							});
							focusAbles.attr('tabindex', '-1');
							setTimeout(function(){$('.swiper-slide-active').attr('aria-hidden','false');
								var focusAbles = $('.swiper-slide-active').find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');

								focusAbles.each(function() {
									$(this).attr('tabindex', function() {
										if ($(this).attr("data-default-tabindex") !="none") {
											return $(this).attr('data-default-tabindex');
										} else {
											$(this).removeAttr('tabindex');
										}
									});
								});
								focusAbles.removeAttr('data-default-tabindex');
								focusAbles.attr('tabindex', '0');
								$(".swiper-notification").text("Slide "+(myslide +1) +" displayed");
							}, 0);
						},
						slideChange: function(swiper){
							var myslide = this.activeIndex;

							$('.swiper-slide').attr('aria-hidden','true');

							/*make all non-focusable*/
							var focusAbles = $('.swiper-wrapper').find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');

							focusAbles.each(function() {
								if (!$(this).attr("data-default-tabindex")){
									$(this).attr('data-default-tabindex', function() {
										if ($(this).attr("tabindex")) {
											return $(this).attr('tabindex');
										} else {
											return "none";
										}
									});
								}
							});
							focusAbles.attr('tabindex', '-1');
							setTimeout(function(){$('.swiper-slide-active').attr('aria-hidden','false');
								var focusAbles = $('.swiper-slide-active').find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');

								focusAbles.each(function() {
									$(this).attr('tabindex', function() {
										if ($(this).attr("data-default-tabindex") !="none") {
											return $(this).attr('data-default-tabindex');
										} else {
											$(this).removeAttr('tabindex');
										}
									});
								});
								focusAbles.removeAttr('data-default-tabindex');
								focusAbles.attr('tabindex', '0');
								$(".swiper-notification").text("Slide "+(myslide +1) +" displayed");
							}, 0);
						},
					},
				}
				new Swiper($(this), swiperParams);
			});
		}

		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		/*
		// post slider
		/*
		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		if ($('.post-swiper.swiper-container').length){
			$('.post-swiper.swiper-container').each(function (i) {
				var swiperParams = {
					autoplay: {
						disableOnInteraction: false,
					},
					slidesPerView: 1,
					loop: true,
					speed: 1200,
					preloadImages: false,
					lazy: true,
					simulateTouch: true,
					queueStartCallbacks: true,
					queueEndCallbacks: true,
					keyboard: {
						enabled: true,
						onlyInViewport: false,
					},
					a11y: {
						enabled: true,
						prevSlideMessage: 'Previous slide',
						nextSlideMessage: 'Next slide',
						paginationBulletMessage: 'Go to slide {{index}}',
					},
					pagination: {
						el: '.post-pagination',
						type: 'bullets',
						clickable: true,
					},
					breakpoints: {

					},
					on: {
						init: function(swiper){
							var myslide = this.activeIndex;

							$('.start-stop-slider').on('click', function(e){
								e.preventDefault();
								if ($(this).children('.pause').hasClass('active')){
									$(this).children('.pause').removeClass('active');
									$(this).children('.play').addClass('active');
									postSlider.autoplay.stop();
								} else {
									$(this).children('.pause').addClass('active');
									$(this).children('.play').removeClass('active');
									postSlider.autoplay.start();
								}
							});

							$('.swiper-slide').attr('aria-hidden','true');
							$('.swiper-slide-active').attr('aria-hidden','false');
							var focusAbles = $('.swiper-wrapper').find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');

							focusAbles.each(function() {
								$(this).attr('data-default-tabindex', function() {
									if ($(this).attr("tabindex")) {
										return $(this).attr('tabindex');
									} else {
										return "none";
									}
								});
							});
							focusAbles.attr('tabindex', '-1');
							setTimeout(function(){$('.swiper-slide-active').attr('aria-hidden','false');
								var focusAbles = $('.swiper-slide-active').find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');

								focusAbles.each(function() {
									$(this).attr('tabindex', function() {
										if ($(this).attr("data-default-tabindex") !="none") {
											return $(this).attr('data-default-tabindex');
										} else {
											$(this).removeAttr('tabindex');
										}
									});
								});
								focusAbles.removeAttr('data-default-tabindex');
								focusAbles.attr('tabindex', '0');
								$(".swiper-notification").text("Slide "+(myslide +1) +" displayed");
							}, 0);
						},
	  					slideChange: function(swiper){
							var myslide = this.activeIndex;

							$('.swiper-slide').attr('aria-hidden','true');

							/*make all non-focusable*/
							var focusAbles = $('.swiper-wrapper').find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');

							focusAbles.each(function() {
								if (!$(this).attr("data-default-tabindex")){
									$(this).attr('data-default-tabindex', function() {
										if ($(this).attr("tabindex")) {
											return $(this).attr('tabindex');
										} else {
											return "none";
										}
									});
								}
							});
							focusAbles.attr('tabindex', '-1');
							setTimeout(function(){$('.swiper-slide-active').attr('aria-hidden','false');
								var focusAbles = $('.swiper-slide-active').find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');

								focusAbles.each(function() {
									$(this).attr('tabindex', function() {
										if ($(this).attr("data-default-tabindex") !="none") {
											return $(this).attr('data-default-tabindex');
										} else {
											$(this).removeAttr('tabindex');
										}
									});
								});
								focusAbles.removeAttr('data-default-tabindex');
								focusAbles.attr('tabindex', '0');
								$(".swiper-notification").text("Slide "+(myslide +1) +" displayed");
							}, 0);
						},
					},
				}
				var postSlider = new Swiper($(this), swiperParams);
			});


		}

		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		/*
		// buttons
		/*
		/* //////////////////////////////////////////////////////////////////////////// */
		/* //////////////////////////////////////////////////////////////////////////// */
		$('a').on('click', function() {
			$(this).addClass('active-link');
		}).on('blur', function() {
			$(this).removeClass('active-link');
		});

		$('button').on('click', function() {
			$(this).addClass('active-link');
		}).on('blur', function() {
			$(this).removeClass('active-link');
		});

	},
	finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    function loadPodcast($id)
    {
      $.ajax({
        url: ajaxurl,
        type: 'GET',
        data: {id: $id, action: 'load_podcast'},
        beforeSend: function() {
          $('.featured-media .container').html('');
          $('.featured-media .load-spinner').show();
        },
        success: function(response) {
          $('.featured-media .load-spinner').hide();
          $('.featured-media .container').html(response);
        }
      });
    }

    if ($('.switch-podcast').length > 0) {
      $('.switch-podcast').click(function() {
        loadPodcast($(this).attr('data-id'));
        $('html, body').animate({ scrollTop: $('.podcast-video').offset().top }, 1000);
        return false;
      });

      // .trigger('click');
      loadPodcast($($('.switch-podcast').get(0)).attr('data-id'));
    }

    if ($('.a2a_follow.addtoany_list a').length > 0) {
      $('.a2a_follow.addtoany_list a').attr('target', '_self');
    }
	},

};



// WEBPACK FOOTER //
// ./scripts/routes/common.js